export default "__VITE_ASSET__B0ghFb_NdSMRHE0NaWzwhw__";